import { buildFreshGateUrl } from "./buildLandingRedirect";

/** 失效页「返回主站」：生成新的 t{时间戳}.主域（保留 agent） */
export function getMainSiteUrl() {
  return buildFreshGateUrl();
}
